import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaTimes,
    FaHome,
    FaUser,
    FaUsersCog,
    FaUserCheck,
    FaUserTie,
    FaFileContract,
    FaChartLine,
    FaSearch,
    FaHandshake,
    FaCog,
    FaLock,
    FaBell,
    FaMoneyBillWave,
    FaIdCard,
    FaUserShield,
    FaUserEdit,
    FaUserCog,
    FaUserFriends,
    FaClipboardCheck,
    FaTools,
    FaBriefcase,
    FaListAlt
} from "react-icons/fa";
import { ShowWhenAuthenticated } from '../../context/AuthContext';
import AuthService from '../../services/AuthService';

const SideMenu = ({ isVisible, onClose }) => {
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const currentUser = AuthService.getCurrentUser();
    const userRoles = currentUser?.roles || [];

    const hasRole = (role) => userRoles.includes(role);

    const toggleSubMenu = (menu) => {
        setActiveSubMenu(activeSubMenu === menu ? null : menu);
    };

    const sideMenuStyles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(5px)',
            zIndex: 999,
        },
        sidebar: {
            position: 'fixed',
            top: '20px',
            bottom: '20px',
            left: isVisible ? '0' : '-300px',
            width: '280px',
            backgroundColor: '#f8f9fa',
            boxShadow: '2px 0 15px rgba(0, 0, 0, 0.2)',
            borderRadius: '0 15px 15px 0',
            transition: 'left 0.3s ease',
            zIndex: 1000,
            padding: '25px',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
        },
        closeButton: {
            alignSelf: 'flex-end',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            marginBottom: '20px',
            color: '#6c757d',
            transition: 'color 0.3s ease',
        },
        menuList: {
            listStyle: 'none',
            padding: 0,
            margin: 0,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
        },
        menuItem: {
            textDecoration: 'none',
            color: '#343a40',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '10px',
            borderRadius: '8px',
            transition: 'background-color 0.3s ease, color 0.3s ease',
        },
        menuItemHover: {
            ':hover': {
                backgroundColor: '#e9ecef',
                color: '#007bff',
            }
        },
        subMenuButton: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#343a40',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '10px',
            borderRadius: '8px',
            transition: 'background-color 0.3s ease, color 0.3s ease',
            width: '100%',
            textAlign: 'left',
        },
        subMenu: {
            backgroundColor: '#fff',
            padding: '15px',
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            marginTop: '10px',
        },
        sectionTitle: {
            margin: '15px 0 5px',
            color: '#007bff',
            fontSize: '0.9rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
        activeSubMenu: {
            backgroundColor: '#e9ecef',
            color: '#007bff',
        }
    };

    return (
        <ShowWhenAuthenticated>
            {/* Overlay sombre et floutré */}
            {isVisible && (
                <div
                    style={sideMenuStyles.overlay}
                    onClick={onClose}
                />
            )}

            {/* Barre latérale */}
            <div style={sideMenuStyles.sidebar}>
                {/* Bouton de fermeture */}
                <button
                    onClick={onClose}
                    style={sideMenuStyles.closeButton}
                    aria-label="Fermer le menu"
                >
                    <FaTimes style={{ width: '24px', height: '24px' }} />
                </button>

                {/* Liste des éléments du menu */}
                <ul style={sideMenuStyles.menuList}>
                    <li>
                        <Link
                            to="/"
                            style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                        >
                            <FaHome/> Accueil
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/profile"
                            style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                        >
                            <FaIdCard/> Mon profil
                        </Link>
                    </li>

                    {/* Section Administrateur - seulement visible pour les admins */}
                    {(hasRole('SuperAdmin') || hasRole('Admin')) && (
                        <>

                            <li>
                                <Link
                                    to="/dashboard"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaChartLine/> Tableau de bord
                                </Link>
                            </li>

                            <h4 style={sideMenuStyles.sectionTitle}>Gestion</h4>
                            <li>
                                <Link
                                    to="/user"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaUserShield/> Utilisateurs
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/professional"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaUserTie/> Professionnels
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/client"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaUserFriends/> Clients
                                </Link>
                            </li>

                            {/*<li>
                                <Link
                                    to="/profile-approval"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaClipboardCheck/> Validation des profils
                                </Link>
                            </li>*/}


                            <li>
                                <Link
                                    to="/request"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaClipboardCheck/>Demandes
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/contracts"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract/>Contrats (clients)
                                </Link>
                            </li>


                            <li>
                                <Link
                                    to="/contrat-employe"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract/> Contrats (employés)
                                </Link>
                            </li>

                            {/* Section commune à tous les rôles */}
                            <h4 style={sideMenuStyles.sectionTitle}>Paramètres</h4>
                            {/*<li>
                                <Link
                                    to="/settings"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaUserCog/> Gestion des rôles
                                </Link>
                            </li>*/}
                            {/*<li>
                                <Link
                                    to="/servicehds"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaTools/> Gestion des professions
                                </Link>
                            </li>*/}

                            <li>
                            <Link
                                to="/services-management"
                                style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                            >
                                <FaUserCog/> Services
                            </Link>
                        </li>
                            <li>
                                <Link
                                    to="/settings"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaCog /> Paramétrage
                                </Link>
                            </li>
                        </>
                    )}

                    {/* Section Aide Ménagère - seulement visible pour les pros */}
                    {hasRole('PROFESSIONAL') && (
                        <>
                            <h4 style={sideMenuStyles.sectionTitle}>Aide Ménagère</h4>
                            {/*<li>
                                <Link
                                    to="/pro-dashboard"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaChartLine/> Tableau de bord
                                </Link>
                            </li>*/}

                            {/*<li>
                                <Link
                                    to="/profile-submit"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaListAlt/> Mes demandes
                                </Link>
                            </li>*/}
                            <li>
                                <Link
                                    to="/my-contrat"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract /> Mes contrats
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/identification"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract /> Mon Identification
                                </Link>
                            </li>

                            {/*<li>
                                <Link
                                    to="/availability"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract /> Mes Préférences
                                </Link>
                            </li>*/}
                        </>
                    )}

                    {/* Section Client - seulement visible pour les clients */}
                    {hasRole('CLIENT') && (
                        <>
                            <h4 style={sideMenuStyles.sectionTitle}>Client</h4>
                            {/*<li>
                                <Link
                                    to="/client-dashboard"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaChartLine/> Tableau de bord
                                </Link>
                            </li>*/}
                            <li>
                                <Link
                                    to="/client-identification"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaIdCard />  Mon Identification
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/professional-candidate"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaSearch/> Rechercher une aide
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/client-list"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaBriefcase/> Mes demandes
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/client-contracts"
                                    style={{...sideMenuStyles.menuItem, ...sideMenuStyles.menuItemHover}}
                                >
                                    <FaFileContract/> Mes contrats
                                </Link>
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </ShowWhenAuthenticated>
    );
};

export default SideMenu;